import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { getLinkFichaCatalograficaByMarca } from '../commons/menu/biblioteca-virtual/ficha-catalografica/ficha-catalografica.config';
import { getItensMenuConfig } from '../commons/menu/menu.config';
import { paraMsalConfiguration } from '../commons/msal.commons';
import { getTapumeConfig } from '../commons/tapume-erro-carregamento/tapume-erro-carregamento.config';
import { Environment } from '../types';

const buildSettings = (): UserManagerSettings => ({
  authority: 'https://login.microsoftonline.com/da49a844-e2e3-40af-86a6-c3819d704f49/v2.0',
  client_id: '9a78b9e0-8a51-4577-bc87-0ab1e3e556e3',
  redirect_uri: `${window.location.protocol}//${window.location.host}`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}`,
  monitorSession: false,
  userStore: new WebStorageStateStore({ store: localStorage }),
  prompt: 'select_account',
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: false,
  scope: '9a78b9e0-8a51-4577-bc87-0ab1e3e556e3/.default',
});

const prod = (): Environment => {
  const settings: UserManagerSettings = buildSettings();
  const apiUrl = localStorage.getItem('apiUrl');
  const apiV2Url = localStorage.getItem('apiV2Url');
  const ambiente = 'prd';
  const marca = 'estacio';

  return {
    contextos: [
      {
        host: 'https://educador-frontend.estacioprd.net',
        redirect: 'https://educador-sava-estacio.estacioprd.net',
      },
      {
        host: 'https://educador-aura-estacio.estacioprd.net',
        redirect: 'https://educador-sava-estacio.estacioprd.net',
      },
      { host: 'https://educador-sava-estacio.estacioprd.net' },
      { host: 'https://educador.estacio.sava.prd.yduqs.com.br' },
      { host: 'https://educador.estacio.br' },
    ],
    ambiente,
    marca,
    idClienteEnsineme: 'A39EAE23-8E99-27B8-82FC-D5ABAF8953CD',
    URL_REDIRECT_ENSINEME: 'https://stecine.azureedge.net/repositorio/redirect/_redirect.html',
    URL_REDIRECT_REDEFINIR_SENHA: 'https://account.activedirectory.windowsazure.com/ChangePassword.aspx',
    URL_ESQUECEU_SENHA: 'https://passwordreset.microsoftonline.com/',
    API: apiUrl ?? 'https://sava.estacio.br/apis',
    API_DEDICADA: apiUrl ?? 'https://apis.educador.estacio.br/rest',
    API_V2: apiV2Url ?? 'https://api.estacio.br/aura-frontend',
    URL_ALUNO: 'https://estudante.estacio.br',
    URL_FAQ: '/aura-repo/faq-educador.pdf',
    URL_MANUAL: '/aura-repo/manual-educador.pdf',
    URL_BASE_CALENDARIO_ACADEMICO: '/aura-repo/calendario-academico/',
    EVENT_LOGIN_ENDPOINT: '/v2/eventos-login/educadores',
    userManagerSettings: settings,
    msalConfiguration: paraMsalConfiguration({ settings }),
    GTM_ID: 'GTM-56HT2PR',
    TAMANHO_PAGINA_RESPOSTA_TRABALHOS: 5,
    ITENS_MENU: getItensMenuConfig({ ambiente, marca }),
    URL_FICHA_CATALOGRAFICA: getLinkFichaCatalograficaByMarca(marca),
    TAPUME_CONFIG: getTapumeConfig({ marca }),
    URL_ADOBE_LAUNCH_SCRIPT: 'https://assets.adobedtm.com/0b3049c26621/a6dfba573ee8/launch-8ad17cd6adb6.min.js',
  };
};

export default prod;
